import { useEffect } from "react";
import { setTitle } from "@/hooks/useHeader.ts";
import NotificationsComponent from "@/components/Notifications";
import { useTranslation } from "@/i18n";

const Notifications = () => {
  const { t } = useTranslation();
  useEffect(() => {
    setTitle(t("notifications.title"));
  }, [t]);

  return <NotificationsComponent />;
};

export default Notifications;
